import ConfirmationModal from '@/components/molecules/ConfirmationModal';
import { TRosterItemPerson } from '@/types/Roster.types';
import { TUserAffiliation } from '@/types/User.types';
import { capitalize } from '@/utils/stringUtils';

interface OrganizationRosterUpdateAffiliationModalProps {
  confirmationModalVisible: boolean;
  setConfirmationModalVisible: (modalVisible: boolean) => void;
  updateItemAffiliation: () => void;
  itemToUpdate?: TRosterItemPerson;
  newAffiliation?: TUserAffiliation;
  isUpdatePending: boolean;
}

const OrganizationRosterUpdateAffiliationModal = ({
  confirmationModalVisible,
  setConfirmationModalVisible,
  updateItemAffiliation,
  itemToUpdate,
  newAffiliation,
  isUpdatePending,
}: OrganizationRosterUpdateAffiliationModalProps) => {
  const hasAffiliation = itemToUpdate?.Affiliation && (itemToUpdate?.Affiliation as string) !== 'None';
  const affiliationString = hasAffiliation ? `from ${capitalize(itemToUpdate?.Affiliation ?? '')} ` : '';

  return (
    <ConfirmationModal
      isOpen={confirmationModalVisible}
      onClose={() => setConfirmationModalVisible(false)}
      confirmButtonColor="secondary.500"
      confirmButtonText="Update Affiliation"
      onConfirm={updateItemAffiliation}
      title="Confirm Update"
      description={`Are you sure you want to update ${itemToUpdate?.['First Name']} ${itemToUpdate?.['Last Name']}'s Affiliation ${affiliationString}to ${capitalize(newAffiliation ?? '')}?`}
      confirmLoading={isUpdatePending}
    />
  );
};

export default OrganizationRosterUpdateAffiliationModal;
